// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_activeLink__0Z8y5 {
  width: calc(100% + 27px);
  border-right: 2px solid #ff136d;
  border-radius: 12px 2px 2px 12px;
  background: linear-gradient(0deg, rgba(255, 19, 109, 0.1), rgba(255, 19, 109, 0.1)), #080808;
}
.styles_activeLink__0Z8y5 .styles_icon__4HlfX svg path {
  stroke: #ff136d;
}
.styles_activeLink__0Z8y5 .styles_label__qaQGE {
  color: #ffffff;
}

.styles_link__l3abt:nth-child(4) .styles_icon__4HlfX svg path,
.styles_link__l3abt:last-child .styles_icon__4HlfX svg path {
  fill: #b6b6b6;
}

.styles_link__l3abt:nth-child(4).styles_activeLink__0Z8y5 .styles_icon__4HlfX svg path {
  fill: #ff136d;
}

.styles_wrapper__wpCcP {
  padding: 16px 24px;
  min-height: 54px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.styles_label__qaQGE {
  white-space: nowrap;
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #b6b6b6;
}

.styles_icon__4HlfX svg {
  width: 16px;
}
.styles_icon__4HlfX svg path {
  stroke: #b6b6b6;
}`, "",{"version":3,"sources":["webpack://./src/components/sideMenu/navBlock/navItem/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,+BAAA;EACA,gCAAA;EACA,4FAAA;AADF;AAGE;EACE,eCCG;ADFP;AAIE;EACE,cCbI;ADWR;;AAQE;;EACE,aCOO;ADXX;;AASE;EACE,aChBG;ADUP;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAPF;;AAUA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cClBS;ADWX;;AAUA;EACE,WAAA;AAPF;AASE;EACE,eCzBO;ADkBX","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.activeLink {\n  width: calc(100% + 27px);\n  border-right: 2px solid $pink;\n  border-radius: 12px 2px 2px 12px;\n  background: linear-gradient(0deg, $pink-10, $pink-10), $black-nav-bg;\n\n  .icon svg path {\n    stroke: $pink;\n  }\n\n  .label {\n    color: $white;\n  }\n}\n\n.link:nth-child(4),\n.link:last-child {\n  .icon svg path {\n    fill: $grey-nav;\n  }\n}\n\n.link:nth-child(4).activeLink {\n  .icon svg path {\n    fill: $pink;\n  }\n}\n\n.wrapper {\n  padding: 16px 24px;\n  min-height: 54px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.label {\n  white-space: nowrap;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $grey-nav;\n}\n\n.icon svg {\n  width: 16px;\n\n  path {\n    stroke: $grey-nav;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeLink": `styles_activeLink__0Z8y5`,
	"icon": `styles_icon__4HlfX`,
	"label": `styles_label__qaQGE`,
	"link": `styles_link__l3abt`,
	"wrapper": `styles_wrapper__wpCcP`
};
export default ___CSS_LOADER_EXPORT___;
